<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="mb-2">
    <button (click)="onAddrAdd()" pButton type="button" label="Add Shipping Address" icon="pi pi-plus"
      class="p-button-sm" [disabled]="isReadOnly()"></button>
    <span
      style="margin-left:10px; padding-top: 12px;  font-size:small; font-variant: small-caps; color: red;">{{statusMessage()}}</span>
  </div>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
    <ng-template pTemplate>
      <div class="py-2 w-full h-full">
        <prox-ag-grid [gridOptions]="addrGridOptions" [rowData]="addrs"></prox-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <div class="flex ml-2 mt-3 mb-1">
          <p-button [disabled]="!selectedAddr || isReadOnly()" (click)="onSugAdd()" size="small"
            label="Add Shipping User Groups to Shipping Address" icon="pi pi-plus"></p-button>
        </div>
        <div class="grow py-2 w-full h-full">
          <prox-ag-grid [gridOptions]="sugGridOptions" [rowData]="shippingUserGroups">
          </prox-ag-grid>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>